/**
 * clearUserLocalData — wipes all user-specific keys from localStorage and
 * sessionStorage that accumulate during a session (calendar entries, notes,
 * tour state, pricing flow state, etc.).
 *
 * Call this on sign-out AND on account deletion to prevent stale data
 * from leaking to the next user on the same device.
 */
export function clearUserLocalData(): void {
  // ── Calendar & Notes (CalendarNotes.tsx) ───────────────────────────────
  localStorage.removeItem('calendar_custom_entries');
  localStorage.removeItem('calendar_notes');

  // ── Session / Auth flags (AppStateManager.tsx) ────────────────────────
  localStorage.removeItem('user_signed_out');
  localStorage.removeItem('feedback_dont_ask_again');
  localStorage.removeItem('last_feedback_date');
  localStorage.removeItem('upgrade_modal_auto_shown');

  // ── Tour / onboarding ──────────────────────────────────────────────────
  localStorage.removeItem('app_tour_complete');
  localStorage.removeItem('tour_dismissed');

  // ── Credit / plan flow ─────────────────────────────────────────────────
  sessionStorage.removeItem('pricing_pending_plan');
  sessionStorage.removeItem('upgrade_modal_auto_shown');

  // ── History apply prefill ──────────────────────────────────────────────
  sessionStorage.removeItem('history_apply_optimization_id');
  sessionStorage.removeItem('history_apply_job_id');
  sessionStorage.removeItem('history_apply_job_url');
  sessionStorage.removeItem('history_apply_job_title');
  sessionStorage.removeItem('history_apply_company');

  // ── Payment page active marker (prevents re-redirect after clearPaymentFlowFlags) ──
  sessionStorage.removeItem('ggj_payment_page_active');

  // ── Payment session recovery (cookie-stashed refresh_token for mobile UPI) ──
  localStorage.removeItem('ggj_pay_session_recovery');
  try { document.cookie = 'ggj_pay_rt=;path=/;max-age=0;SameSite=Lax;Secure'; } catch { /* */ }
}
